import { createSignal } from "solid-js";

const useDebounce = () => {
	const [value, setValue] = createSignal("");
	const [debouncedValue, setDebouncedValue] = createSignal("");
	const [timer, setTimer] = createSignal<NodeJS.Timeout>();

	const onValue = (newValue: string) => {
		if (timer()) clearTimeout(timer());

		setValue(newValue);
		setTimer(setTimeout(() => setDebouncedValue(newValue), 500));
	};

	return { debouncedValue, value, onValue };
};
export default useDebounce;
